module.exports = __webpack_public_path__ + "img/weixiuguanli.8988bcba.jpg";